module.exports = __webpack_public_path__ + "media/luxury-2026/original-city-living-5b8a2248.jpg";